module.exports = __webpack_public_path__ + "static/media/U3.63ed4fb7.jpg";